import { SCHEMA_IDS, SITE_NAME, SITE_URL } from './constants'

export const buildWebSiteSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': SCHEMA_IDS.website,
  name: SITE_NAME,
  alternateName: 'hydrashop.vn',
  url: SITE_URL,
  publisher: { '@id': SCHEMA_IDS.organization },
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${SITE_URL}/search?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
})
